/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IBodegasTiposPropiedades from './entidades/bodegasTiposPropiedades';

export default class ModeloBodegasTiposPropiedades {
    public consultarBodegasTiposPropiedades() {
        return manejadorRest<IRespuesta<IBodegasTiposPropiedades>>(
            () => negocio.get('BodegaTipoPropiedad/ConsultarListaBodegaTipoPropiedad'),
            true
        );
    }
    public crearBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        return manejadorRest<IRespuesta<IBodegasTiposPropiedades>>(
            () => negocio.post('BodegaTipoPropiedad/GuardarBodegaTipoPropiedad', bodegasTiposPropiedades),
            true
        );
    }
    public editarBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        return manejadorRest<IRespuesta<IBodegasTiposPropiedades>>(
            () => negocio.put('BodegaTipoPropiedad/EditarBodegaTipoPropiedad', bodegasTiposPropiedades),
            true
        );
    }
    public eliminarBodegasTiposPropiedades(bodegasTiposPropiedades: IBodegasTiposPropiedades) {
        return manejadorRest<IRespuesta<IBodegasTiposPropiedades>>(
            () => negocio.delete('BodegaTipoPropiedad/EliminarBodegaTipoPropiedad', bodegasTiposPropiedades),
            true
        );
    }
    public consultarFiltroBodegasTiposPropiedades(bodegasTiposPropiedades: Partial<IBodegasTiposPropiedades>) {
        return manejadorRest<IRespuesta<IBodegasTiposPropiedades>>(
            () => negocio.post('BodegaTipoPropiedad/ConsultarBodegaTipoPropiedadFiltro', bodegasTiposPropiedades),
            true
        );
    }
}
